import React from 'react';

import { useTheme } from '@mui/material/styles';
import { Box, Card, Grid, Link, Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import PanelSystem from 'resources/panelSystem.svg?react';

import DateTooltip from './DateTooltip';
import MenuOptions from './MenuOptions';
import StatusIndicatorTooltip from './StatusIndicatorTooltip';

const ProposalTable = ({ filterData, handleClickDuplicate, proposals }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const getLink = (item) => {
        if (item.render_status === 'generated')
            return `/panel-layout/preview/${item?.id}`;
        const nextUrl = item.is_bom_express ? 'bom-express' : 'panel-layout';
        return `/${nextUrl}/${item?.designer?.id}`;
    };
    return (
        <>
            {proposals.map((item) => {
                return (
                    <Card
                        key={`proposal-item-${item.id}`}
                        style={{
                            backgroundColor:
                                theme.palette.mode === 'dark' ? '#282b30' : '',
                        }}
                    >
                        <Grid container spacing={0}>
                            <Grid
                                size={{ md: 1, xs: 5 }}
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                <Box p={2}>
                                    <StatusIndicatorTooltip
                                        isGenerated={
                                            item.render_status === 'generated'
                                        }
                                    />
                                </Box>
                            </Grid>

                            <Grid
                                size={{ md: 17, xs: 13 }}
                                sx={{ py: { xs: 1, lg: 2 } }}
                            >
                                <Grid container spacing={0}>
                                    <Grid size={{ xs: 15, lg: 16 }}>
                                        <Link
                                            component={RouterLink}
                                            to={getLink(item)}
                                            sx={{ color: '#000' }}
                                        >
                                            <Typography
                                                variant="body2"
                                                fontWeight={600}
                                            >
                                                {item.name}
                                            </Typography>
                                        </Link>
                                    </Grid>

                                    <MenuOptions
                                        filterData={filterData}
                                        handleClickDuplicate={
                                            handleClickDuplicate
                                        }
                                        isArchived={
                                            item.status_flag === 'archived'
                                        }
                                        proposalId={item.id}
                                        proposalName={item.name}
                                    />
                                </Grid>

                                <Grid container>
                                    <Grid size={18}>
                                        <Box
                                            alignItems="center"
                                            display="flex"
                                            gap={2}
                                        >
                                            <DateTooltip
                                                createdAt={item.created_at}
                                            />

                                            <Box
                                                alignItems="center"
                                                display="flex"
                                                gap={1}
                                            >
                                                <PanelSystem />
                                                <Typography variant="caption">
                                                    {
                                                        item?.designer
                                                            ?.solar_modules
                                                    }{' '}
                                                    u
                                                </Typography>
                                            </Box>

                                            <Typography variant="caption">
                                                {item?.system?.name}
                                            </Typography>

                                            <Typography variant="caption">
                                                {item?.is_bom_express
                                                    ? t('Express')
                                                    : t('Professional')}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Card>
                );
            })}
        </>
    );
};

ProposalTable.propTypes = {
    filterData: PropTypes.object,
    handleClickDuplicate: PropTypes.func,
    proposals: PropTypes.array,
};

export default ProposalTable;
